import waldenTheme from './walden.json';

export const DEFAULT_COLORS = waldenTheme.color;
